// Initialize AOS
AOS.init();
window.addEventListener("load", AOS.refresh);

// Initialize Swiper
document.addEventListener('DOMContentLoaded', function() {
  // Product recommendations swiper
  if (document.querySelector('.moc-recommended .swiper-container')) {
    const swiper = new Swiper('.moc-recommended .swiper-container', {
      slidesPerView: 1.05,
      spaceBetween: 25,
      autoHeight: true,
      pagination: {
        el: '.moc-recommended .swiper-pagination',
        clickable: true
      },
      breakpoints: {
        500: {
          slidesPerView: 1.25,
        },
        700: {
          slidesPerView: 1.5,
        },
        1200: {
          slidesPerView: 3
        }
      }
    });
  }

  // Hero Slider swiper
  const heroSwiper = new Swiper('.hero-slider .swiper-container', {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  });




  // Mega Menu functionality
  function initMegaMenu() {
    document.addEventListener('click', function(e) {
      const childLink = e.target.closest('.child-link');
      if (!childLink) return;

      const hasGrandchildren = childLink.dataset.hasGrandchildren === 'true';
      const handle = childLink.dataset.handle;
      const url = childLink.dataset.url;

      if (!hasGrandchildren) {
        window.location.href = url;
        return;
      }

      e.preventDefault();

      // Find the closest mega menu container
      const megaMenu = childLink.closest('.mega-menu__content');
      if (!megaMenu) return;

      // Remove active classes within this mega menu only
      megaMenu.querySelectorAll('.child-link').forEach(el => el.classList.remove('active'));
      megaMenu.querySelectorAll('.grandchild-links').forEach(el => el.classList.remove('active'));
      megaMenu.querySelectorAll('.mega-content').forEach(el => el.classList.remove('active'));

      // Add active classes
      childLink.classList.add('active');
      megaMenu.querySelector(`.grandchild-links[data-parent="${handle}"]`)?.classList.add('active');
      megaMenu.querySelector(`.mega-content[data-parent="${handle}"]`)?.classList.add('active');
    });
  }

  initMegaMenu();
});